import classNames from 'classnames';
import React from 'react';
import './Spinner.scss';
export function Spinner({ className }) {
    const classes = classNames('spinner-outer-wrapper', { [`${className}`]: className });
    return (React.createElement("div", { className: classes },
        React.createElement("div", { className: 'spinner-inner-wrapper' },
            React.createElement("div", { className: "spinner" }))));
}
